import { makeAutoObservable } from "mobx";

import type { GroupInformationFormType } from "@/components/units";

import type { BrandFullPayload } from "./BrandStore";

type GroupFullPayload = GroupInformationFormType & {
  brands: BrandFullPayload[];
};

export class GroupStore {
  group: GroupInformationFormType | null = null;
  brands: BrandFullPayload[] = [];

  constructor() {
    makeAutoObservable(this);
    this.initDefault();
  }

  init(group: GroupInformationFormType) {
    this.group = group;
  }

  initDefault() {
    this.group = {
      name: "",
      status: "EVALUATING",
      country: "",
      currency: "",
      phone: "",
      address: "",
      commercialRegistration: "",
      VAT: "",
      legalEntityId: "",
      brandsWithBranches: [],
    };
  }

  setIntirePayload(data: GroupFullPayload) {
    this.group = {
      name: data.name,
      country: data.country,
      currency: data.currency,
      legalEntityId: data.legalEntityId || "",
    };
    this.brands = data.brands || [];
  }

  setGroup(group: GroupInformationFormType) {
    this.group = group;
  }

  setBrands(brands: BrandFullPayload[]) {
    this.brands = brands;
  }

  addBrand(brand: BrandFullPayload) {
    if (
      !this.brands.some(
        br => br.details?.googleBusinessId === brand.details?.googleBusinessId
      )
    ) {
      this.brands.push(brand);
    }
  }

  getGroup(): GroupInformationFormType {
    return this.group as GroupInformationFormType;
  }

  getBrandByReferenceNumber(
    brand: BrandFullPayload
  ): BrandFullPayload | undefined {
    return this.brands.find(
      br => br.details?.googleBusinessId === brand.details?.googleBusinessId
    );
  }

  getBrands(): BrandFullPayload[] {
    return this.brands;
  }

  removeBrand(brand: BrandFullPayload) {
    this.brands = this.brands.filter(
      br => br.details?.googleBusinessId !== brand.details?.googleBusinessId
    );
  }

  clear() {
    this.group = null;
    this.brands = [];
  }

  getFullPayload() {
    return {
      ...this.group,
    };
  }
}
